module.exports = __webpack_public_path__ + "img/shuttle.8dcca0db.jpg";